"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Dealer_1 = require("../../commonSteps/dealer/components/Dealer");
var dealerContainerStyles_1 = require("./dealerContainerStyles");
var DealerContainer = function () {
    var styles = dealerContainerStyles_1.default();
    return (<core_1.Box data-test={'checkout:dealer'} className={styles.dealerContainer}>
      <Dealer_1.default />
    </core_1.Box>);
};
exports.default = DealerContainer;
